const COMPONENT_NAME = "Grid";
export {
  COMPONENT_NAME
};
